<header class="theme-header">
  <span class="theme-header__label">(PHOTO MACHINE)</span>

  <!-- Absolutely centred, so it stays centred on the screen rather than being pushed
       off-centre by the two labels having different widths. -->
  <img class="theme-header__logo" src="assets/img/theme/the_portrait/white-logo.png" alt="The Portrait" />

  <span class="theme-header__label theme-header__label--est" [class.is-clickable]="estClickable"
    (click)="onEstClick()">EST 2026</span>
</header>
